@if (src?.length) {
  <span data-image class="rounded-avatar-small" style="background-image: url('{{ src }}');"></span>
} @else {
  <span class="rounded-avatar-small d-flex align-items-center justify-content-center">
    <mat-icon data-placeholder>image</mat-icon>
  </span>
}
